import { render } from "./OrgChart2.vue?vue&type=template&id=6b0a7a9f&scoped=true"
import script from "./OrgChart2.vue?vue&type=script&lang=js"
export * from "./OrgChart2.vue?vue&type=script&lang=js"

import "./OrgChart2.vue?vue&type=style&index=0&id=6b0a7a9f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0a7a9f"]])

export default __exports__